import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { ECOMMERCE_FORM_PATH, SECONDARY_CTA_CLASS } from './ctaStyles';
import { OfferFormCta } from './OfferCtaButtons';

const OfferEcommerce: React.FC = () => (
  <section id="web-ecommerce" className="py-12 bg-[#2F3136]">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="rounded-xl border border-white/10 bg-white/5 p-6 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-white/15 bg-white/10 text-[#B9C4FF]">
            <ShoppingBag className="h-6 w-6" />
          </div>
          <div>
            <h2 className="text-balance text-white font-semibold text-lg mb-1">Besoin d'une boutique en ligne ?</h2>
            <p className="text-gray-300 text-sm">Hors forfait, sur devis personnalisé.</p>
          </div>
        </div>
        <OfferFormCta
          location="ecommerce"
          to={ECOMMERCE_FORM_PATH}
          label="Demander un devis e-commerce"
          icon={ArrowRight}
          className={`${SECONDARY_CTA_CLASS} whitespace-nowrap`}
        />
      </motion.div>
    </div>
  </section>
);

export default OfferEcommerce;
